import {
  SlimNavActionTypes,
  UpdateAirportsActionPayload,
  UpdateDatesActionPayload
} from '../actions/slim-nav';
import { SlimNavUpdateState } from '../states';

export function slimNavReducer(
  state: SlimNavUpdateState = {},
  action: {
    type: string;
    payload: UpdateDatesActionPayload | UpdateAirportsActionPayload;
  }
): SlimNavUpdateState {
  switch (action.type) {
    case SlimNavActionTypes.SLIM_NAV_UPDATE_AIRPORTS: {
      const payload: UpdateAirportsActionPayload =
        action.payload as UpdateAirportsActionPayload;
      return {
        ...state,
        airportChanges: payload
      };
    }
    case SlimNavActionTypes.SLIM_NAV_UPDATE_DATES: {
      const payload: UpdateDatesActionPayload =
        action.payload as UpdateDatesActionPayload;
      return {
        ...state,
        dateChanges: payload
      };
    }
    default:
      return state;
  }
}
